"use client";

import { ChevronRight, Home } from "lucide-react";
import { usePathname } from "next/navigation";
import Link from "next/link";
import React from "react";

export default function HeroStrip() {
  const pathname = usePathname();

  // --- LOGIC: Hide component on Root or /home ---
  if (!pathname || pathname === "/" || pathname === "/home") {
    return null;
  }

  // --- DATA PROCESSING ---
  const segments = pathname
    .split("/")
    .filter((item) => item !== "")
    .map((item) => decodeURIComponent(item));

  return (
    <nav
      aria-label="Breadcrumb"
      className="w-full bg-white border-b border-neutral-100 "
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center h-12">
          <ol className="flex items-center space-x-1">
            {/* 1. Home Icon - Primary to Secondary Hover */}
            <li className="flex items-center">
              <Link
                href="/"
                className="text-gray-700 hover:text-[var(--secondary)] transition-colors duration-300"
              >
                <Home className="w-3.5 h-3.5" />
                <span className="sr-only">Home</span>
              </Link>
            </li>

            {/* 2. Segments Loop */}
            {segments.map((slug, index) => {
              const isLast = index === segments.length - 1;
              const href = `/${segments.slice(0, index + 1).join("/")}`;

              return (
                <li key={index} className="flex items-center">
                  <ChevronRight className="w-3.5 h-3.5 text-neutral-300 mx-1 flex-shrink-0" />

                  {isLast ? (
                    // Last item: Current Page (Secondary Color, Italic, Black weight)
                    <span
                      className="text-[10px] sm:text-xs font-black uppercase italic tracking-widest text-[var(--secondary)] truncate max-w-[120px] sm:max-w-none"
                      aria-current="page"
                    >
                      {slug.replace(/-/g, " ")}
                    </span>
                  ) : (
                    // Parent Pages (Neutral to Secondary Hover)
                    <Link
                      href={href}
                      className="text-[10px] sm:text-xs font-bold uppercase tracking-widest text-gray-700 hover:text-[var(--secondary)] transition-colors duration-300 truncate max-w-[120px] sm:max-w-none"
                    >
                      {slug.replace(/-/g, " ")}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </nav>
  );
}
